import format from "date-fns/format";
import queryString from "query-string";
import { flatten, sortBy } from "lodash";

const state = {
	dateRange: 180,
	endDate: null,
	groupid: 0,
	groups: [],
	healthservices: [],
	healthserviceID: 0,
	hospitalID: 0,
	hospitals: [],
	listingID: 0,
	listings: [],
	organisationID: 0,
	organisations: [],
	startDate: null,
	users: []
};

const getters = {
	dateRange: (state) => state.dateRange,
	startDate: (state) => {
		if (!state.startDate) {
			const date = new Date();
			date.setDate(date.getDate() - state.dateRange);
			return format(date, "yyyy-MM-dd");
		}
		return state.startDate;
	},
	endDate: (state) => {
		if (!state.endDate) {
			return format(new Date(), "yyyy-MM-dd");
		}
		return state.endDate;
	},
	users: (state) => state.users,
	userIDs: (state) => state.users,
	groupIDs: (state) => flatten(state.groups),
	groups: (state) => flatten(state.groups),
	groupID: (state) => state.groupid,
	healthservices: (state) => state.healthservices,
	healthserviceID: (state) => state.healthserviceID,
	healthserviceIDs: (state) => state.healthservices,
	hospitals: (state) => state.hospitals,
	hospitalIDs: (state) => state.hospitals,
	hospitalID: (state) => state.hospitalID,
	listings: (state) => state.listings,
	listingID: (state) => state.listingID,
	query: (state, getters) => {
		return queryString.stringify(
			{
				end: getters.endDate,
				start: getters.startDate,
				users: state.users.length ? state.users.join(",") : undefined,
				groups: state.groups.length ? state.groups.join(",") : undefined,
				listings: state.listings.length ? state.listings.join(",") : undefined,
				hospitals: state.hospitals.length
					? state.hospitals.join(",")
					: undefined,
				healthservices: state.healthservices.length
					? state.healthservices.join(",")
					: undefined,
				group: state.groupid !== 0 ? state.groupid : undefined,
				organisations: state.organisations.length
					? state.organisations.join(",")
					: undefined
			},
			{
				encode: false
			}
		);
	},
	organisationID: (state) => state.organisationID,
	hospitalsFilter: (state, getters) => {
		return (allhospitals) => {
			const hospitals = sortBy(getters.hospitalsList, ["name"]);
			if (allhospitals) {
				return [
					{
						id: 0,
						name: "All hospitals"
					},
					...hospitals
				];
			}
			return hospitals;
		};
	},
	organisations: (state) => state.organisations,
	organisationsFilter: (state, getters) => {
		return (allorganisations) => {
			const organisations = sortBy(getters.organisationsList, ["name"]);
			if (allorganisations) {
				return [
					{
						id: 0,
						name: "All hospitals"
					},
					...organisations
				];
			}
			return organisations;
		};
	}
};

const actions = {
	setReportDate(context, update) {
		context.commit("updateReportDates", update);
	},
	setStartDate(context, value) {
		context.commit("updateReportDates", {
			value,
			position: "start"
		});
	},
	setEndDate(context, value) {
		context.commit("updateReportDates", {
			value,
			position: "end"
		});
	},
	setDateRange(context, range) {
		context.commit("updateDateRange", {
			range
		});
	},
	updateUsers(context, users) {
		context.commit("updateQuery", {
			name: "users",
			value: users
		});
	},
	updateHealthservices(context, healthservices) {
		context.commit("updateQuery", {
			name: "healthservices",
			value: healthservices
		});
	},
	updateHealthServiceID(context, healthserviceID) {
		context.commit("updateQuery", {
			name: "healthserviceID",
			value: healthserviceID
		});
	},
	updateHospitals(context, hospitals) {
		context.commit("updateQuery", {
			name: "hospitals",
			value: hospitals
		});
	},
	updateGroups(context, groups) {
		context.commit("updateQuery", {
			name: "groups",
			value: groups
		});
	},
	updateHospitalID(context, hospitalid) {
		context.commit("updateQuery", {
			name: "hospitalID",
			value: hospitalid
		});
	},
	updateGroupID(context, groupid) {
		context.commit("updateQuery", {
			name: "groupid",
			value: groupid
		});
	},
	updateOrganisations(context, organisations) {
		context.commit("updateQuery", {
			name: "organisations",
			value: organisations
		});
	},
	updateOrganisationID(context, organisationID) {
		context.commit("updateQuery", {
			name: "organisationID",
			value: organisationID
		});
	},
	updateListingID(context, listingID) {
		context.commit("updateQuery", {
			name: "listingID",
			value: listingID
		});
	},
	updateListings(context, listings) {
		context.commit("updateQuery", {
			name: "listings",
			value: listings
		});
	}
};

const mutations = {
	updateDateRange(state, payload) {
		const { range } = payload;
		state.dateRange = range;
	},
	setHospitalID(state, payload) {
		const { hospitalID } = payload;
		state.hospitalID = hospitalID;
	},
	setOrganisationID(state, payload) {
		const { organisationID } = payload;
		state.organisationID = organisationID;
	},
	setListingID(state, payload) {
		const { listingID } = payload;
		state.listingID = listingID;
	},
	updateReportDates(state, { value, position }) {
		state[`${position}Date`] = value;
	},
	updateQuery(state, { name, value }) {
		state[name] = value;
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}; // eslint-disable-line
